import type { ParentType } from '@risksmart-app/domain/src/types/consts/index';
import type { DeleteFormFieldMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteFormFieldDocument,
  GetFormConfigurationByParentTypeDocument,
  GetFormCustomisationDocument,
  GetFormFieldOptionsByParentTypeDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type DeleteFormFieldInput = {
  ParentType: string;
  FieldId: string;
};

export const useDeleteFormField = createMutationHook({
  name: 'deleteFormField',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.formConfiguration.deleteFormField.mutationOptions({
      onSuccess,
    }),
  mapInput: (variables: DeleteFormFieldInput) => ({
    ParentType: variables.ParentType as ParentType,
    FieldId: variables.FieldId,
  }),
  // Invalidate BOTH form-configuration readers — see useInsertFormField for
  // the rationale. `getFormCustomisation` backs the live form render;
  // skipping it leaves an open form stale (RSP-5866).
  invalidate: (trpc) => [
    trpc.frontend.formConfiguration.getByParentTypes.queryKey(),
    trpc.frontend.formConfiguration.getFormCustomisation.queryKey(),
  ],
  mapResponse: (
    _result,
    variables: DeleteFormFieldInput
  ): DeleteFormFieldMutation => ({
    deleteFormField: {
      __typename: 'IdOutput',
      Id: variables.FieldId,
    },
  }),
  graphqlDocument: DeleteFormFieldDocument,
  graphqlVariables: (variables: DeleteFormFieldInput) => ({
    object: {
      ParentType: variables.ParentType,
      FieldId: variables.FieldId,
    },
  }),
  refetchQueries: [
    GetFormConfigurationByParentTypeDocument,
    GetFormFieldOptionsByParentTypeDocument,
    GetFormCustomisationDocument,
  ],
});
